import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";

export function ChecklistLoadingState() {
  return (
    <>
      <Header />
      <Main>
        <div className="flex items-center justify-center p-8">
          <p className="text-muted-foreground">ກຳລັງໂຫຼດ...</p>
        </div>
      </Main>
    </>
  );
}
